'use client';

import type { FC, ReactNode } from 'react';
import DefaultHeader from '@/components/Header/DefaultHeader';
import Footer from '@/components/Footer/Footer';

interface DefaultLayoutProps {
  children: ReactNode;
  showCategoryNav?: boolean;
  showFooter?: boolean;
  showHeader?: boolean;
}

const DefaultLayout: FC<DefaultLayoutProps> = ({
  children,
  showCategoryNav = true,
  showFooter = true,
  showHeader = true,
}) => (
  <div className="default-layout flex flex-col min-h-screen bg-white w-full">
    {showHeader && <DefaultHeader showCategoryNav={showCategoryNav} />}
    <main className="flex-grow">{children}</main>
    {showFooter && <Footer />}
  </div>
);

export default DefaultLayout;
